export default __webpack_public_path__ + "static/media/teams_Footer_Manchester_Sponsorship.2f2b687b.svg";